import { useRequest } from "../../../app/hooks/useRequest";
import { deleteSatisfactionSurveyRequest } from "../SatisfactionSurveyRequests";

export const useDeleteSatisfactionSurvey = () =>
  useRequest(deleteSatisfactionSurveyRequest);
